<template>
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="63" height="63" rx="10" fill="#F1F8FF" />
    <path
      d="M42.9888 22.6666L44.236 21.8332L44.236 21.8332L42.9888 22.6666ZM42.9888 38.3334L41.7416 37.5001L41.7416 37.5001L42.9888 38.3334ZM41.3334 39.9888L40.5001 38.7416L40.5001 38.7416L41.3334 39.9888ZM35 40.998L34.9935 39.498C34.1676 39.5016 33.5 40.1721 33.5 40.998H35ZM35 41L36.3416 41.6708C36.4458 41.4625 36.5 41.2329 36.5 41H35ZM29 41H27.5C27.5 41.2329 27.5542 41.4625 27.6584 41.6708L29 41ZM29 40.998H30.5C30.5 40.1721 29.8324 39.5016 29.0065 39.498L29 40.998ZM22.6666 39.9888L21.8332 41.236L21.8332 41.236L22.6666 39.9888ZM21.0112 38.3334L22.2584 37.5001L22.2584 37.5001L21.0112 38.3334ZM21.0112 22.6666L19.764 21.8332L19.764 21.8332L21.0112 22.6666ZM22.6666 21.0112L21.8332 19.764L21.8332 19.764L22.6666 21.0112ZM41.3334 21.0112L40.5001 22.2584L40.5001 22.2584L41.3334 21.0112ZM45.5 30.5C45.5 28.4245 45.5018 26.755 45.3659 25.419C45.2274 24.0578 44.9337 22.8774 44.236 21.8332L41.7416 23.4999C42.0551 23.9691 42.267 24.5987 42.3813 25.7226C42.4982 26.8716 42.5 28.3621 42.5 30.5H45.5ZM44.236 39.1668C44.9337 38.1226 45.2274 36.9422 45.3659 35.581C45.5018 34.245 45.5 32.5755 45.5 30.5H42.5C42.5 32.6379 42.4982 34.1284 42.3813 35.2774C42.267 36.4013 42.0551 37.0309 41.7416 37.5001L44.236 39.1668ZM42.1668 41.236C42.9857 40.6888 43.6888 39.9857 44.236 39.1668L41.7416 37.5001C41.4133 37.9914 40.9914 38.4133 40.5001 38.7416L42.1668 41.236ZM35.0065 42.4979C36.6177 42.4909 37.9645 42.4608 39.0901 42.3052C40.2397 42.1463 41.2548 41.8454 42.1668 41.236L40.5001 38.7416C40.09 39.0156 39.5567 39.2122 38.6793 39.3335C37.7778 39.4581 36.6189 39.4909 34.9935 39.498L35.0065 42.4979ZM36.5 41V40.998H33.5V41H36.5ZM34.2361 45.882L36.3416 41.6708L33.6584 40.3292L31.5528 44.5403L34.2361 45.882ZM29.7639 45.882C30.6852 47.7246 33.3148 47.7246 34.2361 45.882L31.5528 44.5403C31.737 44.1718 32.263 44.1718 32.4472 44.5403L29.7639 45.882ZM27.6584 41.6708L29.7639 45.882L32.4472 44.5403L30.3416 40.3292L27.6584 41.6708ZM27.5 40.998V41H30.5V40.998H27.5ZM21.8332 41.236C22.7452 41.8454 23.7603 42.1463 24.9099 42.3052C26.0355 42.4608 27.3823 42.4909 28.9935 42.4979L29.0065 39.498C27.3811 39.4909 26.2222 39.4581 25.3207 39.3335C24.4433 39.2122 23.91 39.0156 23.4999 38.7416L21.8332 41.236ZM19.764 39.1668C20.3112 39.9857 21.0143 40.6888 21.8332 41.236L23.4999 38.7416C23.0086 38.4133 22.5867 37.9914 22.2584 37.5001L19.764 39.1668ZM18.5 30.5C18.5 32.5755 18.4982 34.245 18.6341 35.581C18.7726 36.9422 19.0663 38.1226 19.764 39.1668L22.2584 37.5001C21.9449 37.0309 21.733 36.4013 21.6187 35.2774C21.5018 34.1284 21.5 32.6379 21.5 30.5H18.5ZM19.764 21.8332C19.0663 22.8774 18.7726 24.0578 18.6341 25.419C18.4982 26.755 18.5 28.4245 18.5 30.5H21.5C21.5 28.3621 21.5018 26.8716 21.6187 25.7226C21.733 24.5987 21.9449 23.9691 22.2584 23.4999L19.764 21.8332ZM21.8332 19.764C21.0143 20.3112 20.3112 21.0143 19.764 21.8332L22.2584 23.4999C22.5867 23.0086 23.0086 22.5867 23.4999 22.2584L21.8332 19.764ZM30.5 18.5C28.4245 18.5 26.755 18.4982 25.419 18.6341C24.0578 18.7726 22.8774 19.0663 21.8332 19.764L23.4999 22.2584C23.9691 21.9449 24.5987 21.733 25.7226 21.6187C26.8716 21.5018 28.3621 21.5 30.5 21.5V18.5ZM33.5 18.5H30.5V21.5H33.5V18.5ZM42.1668 19.764C41.1226 19.0663 39.9422 18.7726 38.581 18.6341C37.245 18.4982 35.5755 18.5 33.5 18.5V21.5C35.6379 21.5 37.1284 21.5018 38.2774 21.6187C39.4013 21.733 40.0309 21.9449 40.5001 22.2584L42.1668 19.764ZM44.236 21.8332C43.6888 21.0143 42.9857 20.3112 42.1668 19.764L40.5001 22.2584C40.9914 22.5867 41.4133 23.0086 41.7416 23.4999L44.236 21.8332Z"
      fill="url(#paint0_linear_1401_5345)"
    />
    <circle
      cx="38"
      cy="30.5"
      r="1.5"
      fill="url(#paint1_linear_1401_5345)"
      stroke="url(#paint2_linear_1401_5345)"
      stroke-linecap="round"
    />
    <circle
      cx="32"
      cy="30.5"
      r="1.5"
      fill="url(#paint3_linear_1401_5345)"
      stroke="url(#paint4_linear_1401_5345)"
      stroke-linecap="round"
    />
    <circle
      cx="26"
      cy="30.5"
      r="1.5"
      fill="url(#paint5_linear_1401_5345)"
      stroke="url(#paint6_linear_1401_5345)"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1401_5345"
        x1="32"
        y1="20"
        x2="32"
        y2="45.7639"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1401_5345"
        x1="38"
        y1="29"
        x2="38"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1401_5345"
        x1="38"
        y1="29"
        x2="38"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1401_5345"
        x1="32"
        y1="29"
        x2="32"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1401_5345"
        x1="32"
        y1="29"
        x2="32"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1401_5345"
        x1="26"
        y1="29"
        x2="26"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1401_5345"
        x1="26"
        y1="29"
        x2="26"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
